import { render, staticRenderFns } from "./DuplicateManagement.vue?vue&type=template&id=6566b0a9"
import script from "./DuplicateManagement.vue?vue&type=script&lang=js"
export * from "./DuplicateManagement.vue?vue&type=script&lang=js"
import style0 from "./DuplicateManagement.vue?vue&type=style&index=0&id=6566b0a9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports